import React from 'react';
import {Button, Form} from 'antd';
import {ActionsBase} from "./ActionsBase";

class ActionsAddApp extends ActionsBase {

    customButtons(key) {
        return <Button key="actionsAddBtn" icon="plus" type="primary" onClick={(e) => {this.showDrawer()}}>Adicionar</Button>
    }
}

const ActionsAdd = Form.create()(ActionsAddApp);
export default ActionsAdd;


// WEBPACK FOOTER //
// ./src/app/views/actions/ActionsAdd.js